import { HTMLAttributes, ReactNode } from 'react';
import clx from 'classnames';
import { useContentOverflow } from 'src/Hooks';
import Toolbar from 'src/Components/Toolbar/Toolbar';
import st from './PageWithToolbar.module.scss';

interface IPageWithToolbarProps extends HTMLAttributes<HTMLDivElement> {
	/** Отрисовка содержимого тулбара. Если не задана, тулбар не рендерится вовсе */
	renderToolbar?: () => ReactNode;
	/** Дополнительный класс скроллящейся области с контентом */
	contentClassName?: string;
	/** Id скроллящейся области - для мест, где до неё добираются через getElementById */
	contentId?: string;
	/** Дополнительный класс тулбара поверх стилей блока */
	toolbarClassName?: string;
	/** Id тулбара - для мест, где до него добираются через getElementById */
	toolbarId?: string;
	/** Вертикальное выравнивание содержимого тулбара */
	toolbarAlignItems?: 'start' | 'center' | 'right' | 'stretch';
}

/** Страница со скроллящимся контентом и прижатым снизу тулбаром, который
    оформлен как самостоятельный блок и отделяется тенью, когда контент под него уезжает */
const PageWithToolbar: React.FC<IPageWithToolbarProps> = (props) => {
	const {
		renderToolbar,
		contentClassName,
		contentId,
		toolbarClassName,
		toolbarId,
		toolbarAlignItems = 'start',
		className,
		children,
		...otherProps
	} = props;

	// Контент не помещается в свою область, то есть реально скроллится под тулбар
	const { contentRef, innerRef, isOverflowed } =
		useContentOverflow<HTMLDivElement>();

	return (
		<div {...otherProps} className={clx(st.page, className)}>
			<div
				ref={contentRef}
				id={contentId}
				className={clx(st.content, contentClassName)}
			>
				{/* Обёртка нужна, чтобы измерить высоту содержимого */}
				<div ref={innerRef}>{children}</div>
			</div>
			{!!renderToolbar && (
				<Toolbar
					id={toolbarId}
					className={clx(st.toolbar, toolbarClassName, {
						[st.fixed]: isOverflowed,
					})}
					alignItems={toolbarAlignItems}
				>
					{renderToolbar()}
				</Toolbar>
			)}
		</div>
	);
};

export default PageWithToolbar;
